import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router';
import { useAuth } from './AuthProvider';

export function RequireAdmin({ children }: { children: ReactNode }) {
  const state = useAuth();
  const location = useLocation();

  if (state.status === 'loading') {
    return <div className="grid min-h-dvh place-items-center text-muted">لحظة…</div>;
  }
  if (state.status !== 'admin') {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  return children;
}
